import { useLocation } from 'react-router'
import { useState, useEffect } from 'react'

export default function useClosable(ref) {
  const [open, setOpen] = useState(false)
  const { pathname } = useLocation()

  const toggle = () => setOpen(!open)

  useEffect(() => open && toggle(), [pathname])

  useEffect(() => {
    if (!ref) return
    if (!ref.current) return

    document.addEventListener('click', (evt) => {
      if (!ref) return
      if (!ref.current) return

      const isClickInside = ref.current.contains(evt.target)

      if (!isClickInside) setOpen(false)
    })
  }, [ref])

  return [open, toggle]
}
